import react from "react";

import { Radio } from "../radio/Radio";
import { RadioGroup } from "../radio/RadioGroup";

import type { RadioChangeEvent } from "../radio/Radio";
import type { QuizQuestionChangeEvent, QuizQuestionOption } from "../../app";

export interface SingleChoiceQuestionProps {
  answer?: string;
  options?: QuizQuestionOption[];
  isValid?: boolean;
  showValidity?: boolean;
  value?: string;
  onChange?: (event: QuizQuestionChangeEvent<string>) => void;
}

export function getIntent({
  answer,
  option,
  value,
  showValidity,
}: {
  answer?: string;
  option: QuizQuestionOption;
  value: string;
  showValidity?: boolean;
}) {
  if (answer == null || value == null || !showValidity) return;

  if (value === option.value) {
    return answer === option.value ? "success" : "error";
  }
}

export function SingleChoiceQuestion({
  answer,
  isValid,
  options,
  showValidity,
  value = "",
  onChange,
}: SingleChoiceQuestionProps) {
  const handleChange = react.useCallback(
    ({ value }: RadioChangeEvent) => {
      onChange?.({ value });
    },
    [onChange],
  );

  return (
    <div className="SingleChoiceQuestion">
      <RadioGroup value={value} onChange={handleChange}>
        {options?.map((option) => {
          const intent = getIntent({
            value,
            answer,
            option,
            showValidity,
          });

          return (
            <Radio
              key={option.value}
              appearance="card"
              disabled={isValid}
              intent={intent}
              readOnly={isValid}
              value={option.value}
            >
              {option.text}
            </Radio>
          );
        })}
      </RadioGroup>
    </div>
  );
}
